/* Read LPO's displayed minimum tier. Never advertise a one-unit placeholder price. */
(() => {
  const script = document.getElementById('pp-product-schema');
  const root = document.querySelector('.pp-product-studio');
  if (!script || !root) return;
  // Sticker packs already emit an exact native batch offer in Liquid.
  // Rounded per-pack card prices must never replace that complete-order offer.
  if (root.dataset.ppStickerPackStudio === 'true' && ['budget-die-cut-sticker-packs', 'premium-die-cut-sticker-packs'].includes(root.dataset.productHandle)) return;
  const config = JSON.parse(document.getElementById('pp-vat-context')?.textContent || '{}');
  // Do not invent a tax-inclusive offer for an unverified market or an exempt login.
  if (config.country !== 'GB' || config.currency !== 'GBP' || config.exempt) return;
  const product = JSON.parse(script.textContent);
  let frame;
  const refresh = () => {
    frame = null;
    const tiers = [...root.querySelectorAll('.pp-tier')].map(tier => {
      const quantity = Number(tier.querySelector('.pp-tier__qty')?.textContent.replace(/[^\d]/g, ''));
      const unit = tier.querySelector('.pp-tier__unit')?.textContent.match(/£\s*([\d,]+(?:\.\d+)?)/);
      return { quantity, unit: unit ? Number(unit[1].replaceAll(',', '')) : NaN };
    }).filter(tier => tier.quantity > 0 && Number.isFinite(tier.unit) && tier.unit > 0)
      .sort((a, b) => a.quantity - b.quantity);
    if (!tiers.length) return;
    const minimum = tiers[0];
    const nativeCents = Math.round(minimum.quantity * minimum.unit * 100);
    const taxable = root.dataset.vatTaxable !== 'false';
    const gross = config.included || !taxable ? nativeCents : nativeCents + Math.round(nativeCents * .2);
    product.offers = {
      '@type': 'Offer',
      name: `${minimum.quantity} units, current product options`,
      description: `Total for the minimum order of ${minimum.quantity} units with the current product options, including UK VAT where applicable. Review the configured order total before checkout.`,
      url: product.url,
      price: (gross / 100).toFixed(2),
      priceCurrency: 'GBP',
      availability: `https://schema.org/${script.dataset.available === 'true' ? 'InStock' : 'OutOfStock'}`,
      itemCondition: 'https://schema.org/NewCondition',
      seller: { '@id': `${new URL(product.url).origin}/#organization` }
    };
    product.additionalProperty = [{ '@type': 'PropertyValue', name: 'Minimum order quantity', value: minimum.quantity, unitText: 'units' }];
    const json = JSON.stringify(product);
    if (script.textContent !== json) script.textContent = json;
  };
  const observer = new MutationObserver(records => {
    if (records.every(record => record.target === script || script.contains(record.target))) return;
    if (!frame) frame = requestAnimationFrame(refresh);
  });
  observer.observe(root, { subtree: true, childList: true, characterData: true });
  refresh();
})();
